import React, { Component } from 'react';
import {Link} from 'react-router';
import { connect } from 'react-redux';

class Sidebar extends Component {
    componentDidMount(){
        var forEach=function(t,o,r){if("[object Object]"===Object.prototype.toString.call(t))for(var c in t)Object.prototype.hasOwnProperty.call(t,c)&&o.call(r,t[c],c,t);else for(var e=0,l=t.length;l>e;e++)o.call(r,t[e],e,t)};
        var hamburgers = document.querySelectorAll(".hamburger");
        if (hamburgers.length > 0) {
            forEach(hamburgers, function(hamburger) {
                hamburger.addEventListener("click", function() {
                    this.classList.toggle("is-active");
                }, false);
            });
        }
        $('.hamburger').on('click', function () {
            if($('.hamburger').hasClass('is-active')) {
                $('.sidebar-item i, .sidebar-title p').hide();

                $('.sidebar').animate({width: '80px'}, 500 );
                $('.header, .dashboard-wrapper').animate({'padding-left': '80px'}, 500 );
            } else {
                $('.sidebar').animate({width: '200px'}, 500 );
                $('.header, .dashboard-wrapper').animate({'padding-left': '200px'}, 500 );
                setTimeout(function () {
                    $('.sidebar-item i, .sidebar-title p').fadeIn();
                }, 510)

            }
        });
    }

    render() {
        return (
            <div className="sidebar">
                <div className="sidebar-title">
                    <div className="hamburger hamburger--squeeze pull-left">
                        <div className="hamburger-box">
                            <div className="hamburger-inner"></div>
                        </div>
                    </div>
                    <p><Link to={"/dashboard"} activeClassName="active" className="fs25">SPEAKLY</Link></p>
                    <div className="clearfix"></div>
                </div>
                
                <div className="sidebar-item"><Link to={"/users"} activeClassName="active" className=""><span className="glyphicon glyphicon-user" aria-hidden="true" /><i>Users</i></Link></div>
                <div className="sidebar-item"><Link to={"/admins"} activeClassName="active" className=""><span className="glyphicon glyphicon-eye-open" aria-hidden="true" /><i>Admins</i></Link></div>
                <div className="sidebar-item"><Link to={"/language"} activeClassName="active" className=""><span className="glyphicon glyphicon-book" aria-hidden="true" /><i>Languages</i></Link></div>
                <div className="sidebar-item"><Link to={"/notifications"} activeClassName="active" className=""><span className="glyphicon glyphicon-bell" aria-hidden="true" /><i>Notifications</i></Link></div>
                <div className="sidebar-item"><Link to={"/chat"} activeClassName="active" className=""><span className="glyphicon glyphicon-comment" aria-hidden="true" /><i>Chat</i></Link></div>
                <div className="sidebar-item"><Link to={"/subscription"} activeClassName="active" className=""><span className="glyphicon glyphicon-tags" aria-hidden="true" /><i>Subscription</i></Link></div>
                <div className="sidebar-item"><Link to={"/static_page"} activeClassName="active" className=""><span className="glyphicon glyphicon-list" aria-hidden="true" /><i>Static pages</i></Link></div>
                <div className="sidebar-item"><Link to={"/email_template"} activeClassName="active" className=""><span className="glyphicon glyphicon-envelope" aria-hidden="true" /><i>Email templates</i></Link></div>
                <div className="sidebar-item"><Link to={"/settings"} activeClassName="active" className=""><span className="glyphicon glyphicon-cog" aria-hidden="true" /><i>Settings</i></Link></div>
            </div>
        );
    }
}


export default connect(null, null)(Sidebar);


// WEBPACK FOOTER //
// ./src/components/sidebar.js